/**
 * @generated SignedSource<<33d65c1077e17713fea519ea8e70e138>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ListItemDescriptionContent_images$data = ReadonlyArray<{
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"Image_image">;
  readonly " $fragmentType": "ListItemDescriptionContent_images";
}>;
export type ListItemDescriptionContent_images$key = ReadonlyArray<{
  readonly " $data"?: ListItemDescriptionContent_images$data;
  readonly " $fragmentSpreads": FragmentRefs<"ListItemDescriptionContent_images">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "ListItemDescriptionContent_images",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Image_image"
    }
  ],
  "type": "Image",
  "abstractKey": null
};

(node as any).hash = "2d52ad0420e7db3d95603ac6d11e3498";

export default node;
